module.exports = __webpack_public_path__ + "img/icons.fd7828c1.svg";